/**
 * Utility functions for asset display, date formatting, and ID generation
 */

/**
 * Display an optional field value. Returns "-" for null, undefined, or empty string.
 * Otherwise returns the value as a string.
 */
export function displayOptionalField(
  value: string | number | boolean | null | undefined
): string {
  if (value === null || value === undefined || value === '') {
    return '-';
  }
  return String(value);
}

/**
 * Format a date string to YYYY-MM-DD format.
 * Returns "-" if the input is null, undefined, or empty string.
 */
export function formatDate(dateStr: string | null | undefined): string {
  if (!dateStr || dateStr.trim() === '') {
    return '-';
  }

  const date = new Date(dateStr);
  if (isNaN(date.getTime())) {
    return dateStr; // Return raw value if parsing fails
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}

/**
 * Generate a UUID v4 string using the Web Crypto API.
 */
export function generateAssetId(): string {
  return crypto.randomUUID();
}
